import React, { useEffect } from 'react';
import { Header } from './Header';
import { AboutSection } from './AboutSection';
import { CEOMessageSection } from './CEOMessageSection';
import { Footer } from './Footer';

export const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <AboutSection />
        <CEOMessageSection />
      </main>
      <Footer />
    </div>
  );
};
